import React, { useEffect, useState } from 'react';
import { setSportPreference, getUserPreference, fetchAvailableSports } from './Api';

const Sports_Pref_Select = () => {
  const [selectedSportId, setSelectedSportId] = useState('');
  const [availableSports, setAvailableSports] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [preferenceData, sportsList] = await Promise.all([
          getUserPreference(),
          fetchAvailableSports(),
        ]);

        if (Array.isArray(sportsList)) {
          setAvailableSports(sportsList);
        }

        // Only set the user's preference if it exists and is in the list
        if (preferenceData?.sport_id && Array.isArray(sportsList)) {
          const match = sportsList.find(sport => sport.id === preferenceData.sport_id);
          if (match) {
            setSelectedSportId(match.id.toString());
          } else {
            // Preference not found: keep placeholder selected
            setSelectedSportId('');
          }
        } else {
          // No preference: keep placeholder selected
          setSelectedSportId('');
        }

      } catch (error) {
        console.error('Error loading preference or sports:', error.message);
        setSelectedSportId(''); // fallback to placeholder on error
      }
    };

    fetchData();
  }, []);

  const handleChange = async (e) => {
    const sportId = e.target.value;
    setSelectedSportId(sportId);

    if (sportId) {
      try {
        await setSportPreference({ sport_id: parseInt(sportId, 10) });
        console.log('Sport preference updated with ID:', sportId);
      } catch (error) {
        console.error('Failed to update sport preference:', error.message);
      }
    }
  };

  return (
    <div className="col-md-6 mb-3 mb-md-0">
      <label className="form-label">Sport</label>
      <select
        className="form-select"
        value={selectedSportId}
        onChange={handleChange}
      >
        <option value="">Select sport</option>
        {availableSports.map((sport) => (
          <option key={sport.id} value={sport.id}>
            {sport.display_name}
          </option>
        ))}
      </select>
    </div>
  );
};

export default Sports_Pref_Select;
